import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'regulations-en',
    templateUrl: './regulations-en.component.html',
    styleUrls: ['./regulations-en.component.scss']
})
export class RegulationsEnComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
